module.exports = __webpack_public_path__ + "img/eae-slide-2.c9b0e89e.jpg";